// Translation: Terms of service > Landing > Form (English)
export default Object.freeze({})
